<template>
  <div class="page-header">
    <div>
      <div class="page-kicker">{{ kicker }}</div>
      <h1>{{ title }}</h1>
      <p v-if="description">{{ description }}</p>
    </div>
    <div class="page-actions"><slot name="actions" /></div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: { type: String, required: true },
    description: { type: String, default: '' },
    kicker: { type: String, default: 'COMMUNITY GOVERNANCE SIMULATION' }
  }
}
</script>
